import React, { SyntheticEvent, useEffect, useState } from "react";
import fotaFileTypeEnum from "../../constants/fota-file-type-enum";
import { useStore } from "../../contexts/StoreProvider";
import { formatMessage } from "../../translations/format-message";
import { ActionFormatter } from "../../shared-components/Grid/GridFormatter";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import fotaViewTypeEnum, {
  ModuleToOpen,
} from "../../constants/fota-view-type-enum";
import Grid from "../../shared-components/Grid/Grid";
import { FormattedMessage } from "react-intl";
import Pagination from "../../shared-components/Grid/Pagination";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from "../../models/ICommon";
import no_user from "../../assets/Images/svg/nofotajet.svg";
import userSettingEnum from "../../constants/user-setting-enum";
import { observer } from "mobx-react";
import AddEditMzlRelease from "./components/add-edit-mzl-release";
import AddPopupHOC from "../../shared-components/popup/add/add-popup-hoc";
import systemModuleEnum from "../../constants/system-module-enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import {
  isOperationPermitted,
  showIcons,
} from "../../helpers/action-permission-helper";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import toast from "react-hot-toast";

interface IProps {
  selectedId: number;
  setSelectedId: React.Dispatch<React.SetStateAction<number>>;
  selectedRow: any;
  setSelectedRow: React.Dispatch<any>;
  openPanel: boolean;
  setOpenPanel: React.Dispatch<React.SetStateAction<boolean>>;
  closePanelHandler: () => void;
  pageInfo: IPageInfo;
  setPageInfo: React.Dispatch<React.SetStateAction<IPageInfo>>;
  deletePopupToggleHandler: () => void;
  showDeletePopup: boolean;
}
const FotaMzlReleaseView = (props: IProps) => {
  const { preferencesStore, fotaMzlReleaseStore } = useStore();
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    inProgress,
    isSelectedView,
    fotaModemConfigList,
    fotaJetConfigList,
    getFotaModemConfigList,
    getFotaJetConfigList,
    isAddUpdatePopupOpen,
    addUpdateFotaState,
    deleteFotaMzlConfigState,
    setIsAddUpdatePopupOpen,
    setSelectedView,
    GetMzlFotaModemConfigListService,
    GetMzlFotaJetConfigListService,
    resetAddUpdateFotaState,
    DeleteFotaModemConfigService,
    DeleteFotaJetConfigService,
    resetDeleteFotaMzlConfigState,
  } = fotaMzlReleaseStore;
  const {
    selectedId,
    setSelectedId,
    selectedRow,
    setSelectedRow,
    openPanel,
    setOpenPanel,
    closePanelHandler,
    pageInfo,
    setPageInfo,
  } = props;

  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];

  const [modemPageLimitInfo, setModemPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaModemPageSizeLimitConfig,
    isPageLimitChange: false,
  });

  const [jetPageLimitInfo, setJetPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaJetPageSizeLimitConfig,
    isPageLimitChange: false,
  });

  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };
  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageSizeLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages:
        isSelectedView.view === fotaViewTypeEnum.Modem
          ? fotaModemConfigList?.PagingDetails?.TotalPages
          : fotaJetConfigList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    if (isSelectedView.view === fotaViewTypeEnum.Modem)
      setModemPageLimit({
        pageLimit: parseInt(evt.target.value),
        isPageLimitChange: true,
      });
    else
      setJetPageLimit({
        pageLimit: parseInt(evt.target.value),
        isPageLimitChange: true,
      });
    setUserSetting(
      isSelectedView.view == fotaViewTypeEnum.Modem
        ? userSettingEnum.FotaModemPageSizeLimitConfig
        : userSettingEnum.FotaJetPageSizeLimitConfig,
      parseInt(evt.target.value)
    );
  };
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);
  const callGetFotaListService = () => {
    if (isSelectedView.view === fotaViewTypeEnum.Modem) {
      GetMzlFotaModemConfigListService(
        pageInfo.currentPage,
        modemPageLimitInfo.pageLimit
      );
    } else {
      GetMzlFotaJetConfigListService(
        pageInfo.currentPage,
        jetPageLimitInfo.pageLimit
      );
    }
  };

  useEffect(() => {
    callGetFotaListService();
  }, []);

  useEffect(() => {
    if (isSelectedView.isViewChanged) {
      setSelectedView({ ...isSelectedView, isViewChanged: false });
      callGetFotaListService();
      setPageInfo({
        ...pageInfo,
        currentPage: 1,
        isRefreshPage: true,
        isPagerChange: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedView.isViewChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages:
        isSelectedView.moduleToOpen === ModuleToOpen.Config
          ? fotaModemConfigList?.PagingDetails?.TotalPages
          : fotaJetConfigList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFotaModemConfigList, getFotaJetConfigList]);

  useEffect(() => {
    if (modemPageLimitInfo.isPageLimitChange) {
      setModemPageLimit({ ...modemPageLimitInfo, isPageLimitChange: false });
      callGetFotaListService();
    }
  }, [modemPageLimitInfo.pageLimit]);

  useEffect(() => {
    if (jetPageLimitInfo.isPageLimitChange) {
      setJetPageLimit({ ...jetPageLimitInfo, isPageLimitChange: false });
      callGetFotaListService();
    }
  }, [jetPageLimitInfo.pageLimit]);

  useEffect(() => {
    if (addUpdateFotaState.success) {
      resetAddUpdateFotaState();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateFotaState.success]);

  const openAddPopupHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    closePanelHandler();
    setSelectedId(row.Id);
    setIsAddUpdatePopupOpen(true);
  };
  const deleteClickHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.deletePopupToggleHandler();
  };

  const deleteHandler = () => {
    if (isSelectedView.view === fotaViewTypeEnum.Modem)
      DeleteFotaModemConfigService(selectedId);
    else DeleteFotaJetConfigService(selectedId);
  };

  useEffect(() => {
    if (deleteFotaMzlConfigState.success) {
      toast.success(formatMessage("deleted_success"));
      resetDeleteFotaMzlConfigState();
      props.deletePopupToggleHandler();
      callGetFotaListService();
    }
  }, [deleteFotaMzlConfigState.success]);

  useEffect(() => {
    if (deleteFotaMzlConfigState.error) {
      toast.error(formatMessage(deleteFotaMzlConfigState.error));
      resetDeleteFotaMzlConfigState();
    }
  }, [deleteFotaMzlConfigState.error]);

  const getFotaFileTypeHandler = (fileType: fotaFileTypeEnum) => {
    if (fileType == fotaFileTypeEnum.NoConvert) return formatMessage("no_convert");
    else if (fileType == fotaFileTypeEnum.ASCII) return formatMessage("ASCII");
    else return "";
  };


  const actionIcons: IActionFormatter[] = showIcons(
    [
      {
        dataField: "isEdit",
        handler: openAddPopupHandler,
        icon: faPencilAlt,
        isDisable: false,
        title: "edit",
        action: "edit",
        varient: "primary",
      },
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: false,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
    ],
    systemModuleEnum.Fota
  );

  const configColumns: any = [
    {
      dataField: "CreatedDate",
      text: formatMessage("created_date"),
    },
    {
      dataField: "EffectiveDateTimestamp",
      text: formatMessage("effective_date"),
    },
    {
      dataField: "ConfigName",
      text: formatMessage("fota_config_name"),
    },
    {
      dataField: "Version",
      text: formatMessage("version"),
    },
    {
      dataField: "FileType",
      text: formatMessage("sending_method"),
      formatter: (cell: any, row: any) => {
        return (
          <>
            <span>{getFotaFileTypeHandler(cell)}</span>
          </>
        );
      },
    },
    {
      dataField: "FileName",
      text: formatMessage("file_name"),
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "",
      formatter: ActionFormatter(actionIcons),
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
    },
  ];

  return (
    <>
      {isAddUpdatePopupOpen && (
        <>
          <AddEditMzlRelease
            id={selectedId}
            modalClosed={() => {
              setIsAddUpdatePopupOpen(false);
            }}
          />
        </>
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title={
            isSelectedView.view === fotaViewTypeEnum.Modem
              ? "delete_modem_config"
              : "delete_jet_config"
          }
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message={
            isSelectedView.view === fotaViewTypeEnum.Modem
              ? "message_delete_modem_config_confirm"
              : "message_delete_jet_config_confirm"
          }
          isLoading={deleteFotaMzlConfigState.inProgress}
        />
      )}

      <div className="table_items_list">
        {inProgress && <FormLoader loading={inProgress} />}
        {getFotaModemConfigList.length > 0 ||
          getFotaJetConfigList.length > 0 ? (
          <div
            className={`card mt-3 changingPanel ${openPanel ? "panelOpen" : ""
              }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                {isSelectedView.view == fotaViewTypeEnum.Modem ? (
                  <Grid
                    data={getFotaModemConfigList}
                    columns={configColumns}
                    keyField="Id"
                    loading={inProgress}
                  />
                ) : (
                  <Grid
                    data={getFotaJetConfigList}
                    columns={configColumns}
                    keyField="Id"
                    loading={inProgress}
                  />
                )}
              </div>
            </div>

            {getFotaModemConfigList.length > 0 ||
              getFotaJetConfigList.length > 0 ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageSizeLimitChanged}
                    value={
                      isSelectedView.view === fotaViewTypeEnum.Modem
                        ? modemPageLimitInfo.pageLimit
                        : jetPageLimitInfo.pageLimit
                    }
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={
                      isSelectedView.view === fotaViewTypeEnum.Modem
                        ? modemPageLimitInfo.pageLimit
                        : jetPageLimitInfo.pageLimit
                    }
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              <FormattedMessage id="no_fota_config" />
            </p>
            <p className="mb-3">{formatMessage("no_fota_config_msg")}</p>
            {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
              <LoaderButton
                text="add_configuration"
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
                  openAddPopupHandler({ Id: -1 }, e)
                }
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default DeletePopupHOC(AddPopupHOC(observer(FotaMzlReleaseView)));
